import { ItemShownEvent } from '~/shared/event_subjects'
import GtmEmitter from './gtm_emitter'
import { DataWithName } from './gtm_emitter_state'

import GtmEmitterState from './gtm_emitter_state'
import TerminatedGtmEmitterState from './terminated_gtm_emitter_state'
import PlaceEnteredGtmEmitterState from './place_entered_gtm_emitter_state'

// page に enter した状態
export default class InPageGtmEmitterState extends GtmEmitterState {
  attachedEvent: DataWithName | null

  constructor (attachedEvent: DataWithName | null = null) {
    super()
    this.attachedEvent = attachedEvent
  }

  onEnterState (context: GtmEmitter) {
    context.emitEventData({ event: 'page_enter', storeData: context.store })
    context.timeCounter.start()

    if (this.attachedEvent) {
      context.forceEmitEvent(this.attachedEvent.name, this.attachedEvent.data)
    }
  }

  onPlaceChanged (context: GtmEmitter, e: ItemShownEvent) {
    context.timeCounter.stop()
    context.emitEventData({ event: 'page_leave', storeData: context.store })
    context.changeState(new PlaceEnteredGtmEmitterState(e))
  }

  onEnterPage (context: GtmEmitter, pageData: {}) {
    context.timeCounter.stop()
    context.emitEventData({ event: 'page_leave', storeData: context.store })
    context.clearPageData()
    context.store.pageData = pageData
    context.changeState(new InPageGtmEmitterState())
  }

  onEvent (context: GtmEmitter, name: string, data: {} = {}) {
    context.forceEmitEvent(name, data)
  }

  terminate (context: GtmEmitter) {
    context.timeCounter.stop()
    context.emitEventData({ event: 'page_leave', storeData: context.store })
    context.changeState(new TerminatedGtmEmitterState())
  }
}
